import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';

const ConfirmDeleteImagesDialog = ({ onClose, onDelete, imageLength }) => {
    const handleDelete = e => {
        e.preventDefault();
        onDelete();
        onClose();
    };

    return (
        <Dialog onClose={onClose} open={true}>
            <DialogTitle>
                Delete {imageLength} {imageLength === 1 ? 'image' : 'images'}
            </DialogTitle>
            <DialogContent>
                <Alert severity="warning" sx={{ marginBottom: '20px' }}>
                    {`Are you sure you want to delete ${imageLength === 1 ? 'this image' : 'these images'} from your account?`}
                </Alert>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleDelete}>Delete</Button>
                <Button variant="outlined" onClick={onClose}>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDeleteImagesDialog;